import { ReferBanner } from './ReferBanner';
import {
  LegacyLoadingCard,
  LegacySellerCard,
  LoadingCard,
  SellerCard,
} from './SellerCard';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { Seller } from '../Seller.types';

type SellersProps =
  | {
      sellers: Seller[] | null;
      displaySellers: Seller[] | undefined;
      filter?: never;
    }
  | {
      sellers: Seller[] | null;
      filter: string | null;
      displaySellers?: never;
    };

export function Sellers({ sellers, displaySellers, filter }: SellersProps) {
  const isMobile = useMediaQuery('(max-width: 624px)');

  if (displaySellers !== undefined) {
    return (
      <section>
        <div className="mb-m flex items-center gap-l">
          <span className="inline-flex items-center gap-[6px] text-xs font-reg text-secondary-40">
            <span className="inline-block h-[8px] w-[8px] rounded-full bg-success-mid" />
            Interest-free
          </span>
          <span className="inline-flex items-center gap-[6px] text-xs font-reg text-secondary-40">
            <span className="inline-block h-[8px] w-[8px] rounded-full bg-structure-80" />
            Interest-bearing
          </span>
          <span className="ml-auto text-xs font-reg text-secondary-60">
            Your spending limit works with all suppliers below
          </span>
        </div>
        {!sellers ? (
          <div className="grid grid-cols-[repeat(auto-fit,_minmax(200px,_1fr))] gap-xl">
            {Array(9)
              .fill(null)
              .map((_, i) => (
                <LoadingCard key={i} />
              ))}
          </div>
        ) : displaySellers.length === 0 ? (
          <div className="flex flex-col items-center gap-m py-2xl text-center text-secondary-40">
            <span className="text-m font-med">No suppliers found</span>
            <span className="text-s font-reg">
              Try adjusting your search or filters.
            </span>
          </div>
        ) : (
          <div className="grid grid-cols-[repeat(auto-fit,_minmax(200px,_1fr))] gap-xl">
            {displaySellers.map((seller, i) => (
              <SellerCard key={i} seller={seller} />
            ))}
          </div>
        )}
      </section>
    );
  }

  const filteredSellers =
    filter === null
      ? sellers
      : sellers?.filter((seller) => seller.industry === filter);

  return (
    <section>
      {filter ? (
        <h2 className="mb-xs capitalize">{filter} Suppliers</h2>
      ) : (
        <h2 className="mb-xs">Featured iwocaPay Suppliers</h2>
      )}
      <span className="mb-xl block text-s font-reg">
        Select a supplier to open their website.
      </span>
      {isMobile && (
        <div className="mb-l">
          <ReferBanner />
        </div>
      )}
      <div className="grid grid-cols-[repeat(auto-fit,_minmax(200px,_1fr))] gap-xl">
        {sellers
          ? filteredSellers?.map((seller, i) => (
              <LegacySellerCard key={i} seller={seller} />
            ))
          : Array(9)
              .fill(null)
              .map((_, i) => <LegacyLoadingCard key={i} />)}
      </div>
    </section>
  );
}
